import {FormArray, FormControl, FormGroup} from "@angular/forms";

export interface Model3dForm {
    id: FormControl<any>;
    name: FormControl<string | null>;
    description: FormControl<string | null>;
    url: FormControl<string | null>;
    file: FormControl<File>;
    filetype: FormControl<string>;
    coverImage: FormControl<File>;
    defaultColor: FormControl<string>;
    defaultMaterial: FormGroup<{id: FormControl<number>, name: FormControl<string>}>;
    offsetRotation: FormArray<FormControl<number>>;
    offsetPosition: FormArray<FormControl<number>>;
}

export function getNewModel3dForm(file: File){
    return new FormGroup( <Model3dForm> {
        id: new FormControl(undefined),
        name: new FormControl(file.name),
        description: new FormControl(''),
        url: new FormControl(''),
        file: new FormControl(file),
        filetype: new FormControl(file.name.split('.').pop()),
        coverImage: new FormControl(undefined),
        defaultColor: new FormControl("#3F888F"),
        defaultMaterial: new FormGroup({ id: new FormControl(1), name: new FormControl('Powder Coated')}),
        offsetRotation: new FormArray([
            new FormControl(0.5),
            new FormControl(-0.5),
            new FormControl(0.5),
            new FormControl(0.5)
        ]),
        offsetPosition: new FormArray([
            new FormControl(0),
            new FormControl(0),
            new FormControl(0)
        ])
    } )
}

export function modifyModel3dForm(model3d: any = undefined) {
    return new FormGroup( <Model3dForm> {
        id: new FormControl(model3d?.id),
        name: new FormControl(model3d?.name),
        description: new FormControl(model3d?.description),
        url: new FormControl(model3d?.url),
        file: new FormControl(undefined),
        filetype: new FormControl(model3d?.filetype),
        coverImage: new FormControl(model3d?.coverImage),
        defaultColor: new FormControl("#3F888F"),

        defaultMaterial: new FormGroup(
            {
                id: new FormControl( model3d?.material?.id ?? 1),
                name: new FormControl( model3d?.material?.name ?? 'Powder Coated')
            }
        ),

        offsetRotation: new FormArray(
            model3d?.offsetRotation.map((i: number) => new FormControl(i))
            ?? [
                new FormControl(0.5),
                new FormControl(-0.5),
                new FormControl(0.5),
                new FormControl(0.5)
            ]
        ),

        offsetPosition: new FormArray(
            model3d?.offsetPosition.map((i: number) => new FormControl(i))
            ?? [
                new FormControl(0),
                new FormControl(0),
                new FormControl(0)
            ]
        )

    } )
};